// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//const basePath =  'https://b91b-2c0f-2a80-993-b810-18d-cc9b-c00-f530.ngrok-free.app';
//const authBasePath = 'https://hamburg-cm-era-pulling.trycloudflare.com';
const basePath = 'https://api.v4.kimbocare.com';
const mapApiKey = 'AIzaSyAYdl-amCl3_OkwyiN7mVAPJyDFZ_KIAyA';
export const environment = {
  production: false,
  serviceWorker: false,
  vapidKey:
    'BI-9ryhqMrssYqhg5evENqNEzkBQTDK95eTca6d0DtP-fx5xDlwgnlayzZmu2P66IrT2PoDcS8S3NTp_Mjj8Hi8',
  google_client_id:
    '21777333703-r98tqbnp7gjkuk00fe5pk4g37n025ags.apps.googleusercontent.com',
  mapApiKey,
  basePath,
  appVersion: require('../../package.json').version,
  badge: true,
  name: 'development',
  apiProvider: 'patient-center',
  ssk: 'we-sv-rtw--eüd-§$-fd',
  ssv: 'öer:gerv:vjdf+*dfe#e-ee,',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
